import request from '@/utils/request'

// 新增购物车
export function getProductList(data) {
  return request({
    url: '/server/lazada/product/list',
    method: 'GET',
    params: data
  })
}

// 新增购物车
export function syncByShop(data) {
  return request({
    url: '/server/lazada/product/syncByShop',
    method: 'GET',
    params: data
  })
}

// 新增购物车
export function productOn(data) {
  return request({
    url: '/server/lazada/product/on',
    method: 'GET',
    params: data
  })
}

// 新增购物车
export function productOff(data) {
  return request({
    url: '/server/lazada/product/off',
    method: 'GET',
    params: data
  })
}

//lazada产品批量更新
export function batchUpdate(data) {
  return request({
    url: '/server/lazada/product/batchUpdate',
    method: 'POST',
    data: data
  })
}

// 根据pid同步lazada产品
export function syncById(data) {
  return request({
    url: '/server/lazada/product/syncById',
    method: 'GET',
    params: data
  })
}
// 根据pid同步lazada产品
export function addLazada(data) {
  return request({
    url: '/server/lazada/product/add',
    method: 'POST',
    data: data
  })
}
// 根据pid同步lazada产品
export function listCnt(data) {
  return request({
    url: '/server/lazada/product/listCnt',
    method: 'GET',
    params: data
  })
}
// 根据pid同步lazada产品
export function getCategorySuggestion(data) {
  return request({
    url: '/server/lazada/product/getCategorySuggestion',
    method: 'GET',
    params: data
  })
}
// 根据pid同步lazada产品
export function getCategoryAttributeAllLazada(data) {
  return request({
    url: '/server/lazada/product/getCategoryAttributeAll',
    method: 'GET',
    params: data
  })
}
// 草稿箱删除Lazada产品
export function deletedraftProLazada(data) {
  return request({
    url: '/server/lazada/product/delete',
    method: 'POST',
    params: data
  })
}
